"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    uploadButton: {
        boxShadow: '0 0 0',
        padding: '2pt',
        height: 23,
        '& p': {
            // contradict the default 'none'
            display: 'block',
        },
    },
    downloadButton: {
        minWidth: '0',
        marginLeft: '2pt',
        boxShadow: '0 0 0',
        padding: '2pt',
        height: 23,
        '& p': {
            // contradict the default 'none'
            display: 'block',
        },
    },
}));
//# sourceMappingURL=file-field-styles.js.map